// Shared response handling for API calls.
//
// The API answers an expired or rejected token with 401 and an EMPTY body, so
// calling .json() on it throws "SyntaxError: Unexpected end of JSON input" and
// the real cause (the session ended) is lost. Route responses through readJson
// instead: it drops the dead token - which is what every caller's
// "you may want to remove the invalid token" comment always intended - and
// returns null so the caller can bail out.
//
// 400 is deliberately allowed through to .json(): several actions return
// BadRequest with a JSON body (for example { email: "No user with this
// email" }) that the callers inspect.
export function readJson(response, label) {
  if (response.status === 401) {
    localStorage.removeItem('token');
    console.warn(label + ': not authenticated (401)');
    return null;
  }

  if (!response.ok && response.status !== 400) {
    throw new Error(label + ' responded ' + response.status);
  }

  return response.json();
}

export default readJson;



// WEBPACK FOOTER //
// ./src/actions/apiResponse.js